import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from 'wisestep-api';
import { Spinner, IUserDTO } from 'wisestep-base';

import { useWorkspaceContext, useUserContext } from '../../../context';

export const WorkspaceState = () => {
  const navigate = useNavigate();
  const user = useUserContext();
  const loggedInUser = useUserContext().userDTO;

  const workspaceContext = useWorkspaceContext();

  useEffect(() => {
    (async function () {
      if (!loggedInUser?.id && user.setUser) {
        const userReq = await getUser();
        const userRes: IUserDTO = userReq.data;
        const userState = { ...user };
        userState.userDTO = userRes;
        user.setUser({ ...userState });
      }
    })();
  }, [loggedInUser, user]);

  useEffect(() => {
    if (
      window.location.pathname !== '/workspace-otp' &&
      !window.location.pathname.includes('/data-protection') &&
      !location.pathname.includes('/subscription') &&
      !location.pathname.includes('/unsubscribe') &&
      !location.pathname.includes('/subscribed')
    ) {
      if (workspaceContext.id && workspaceContext['onBoardingQuestionAnswered'] === false) {
        navigate('/onboarding-questions');
      } else if (workspaceContext.id) {
        navigate('/');
        window.location.reload();
      } else {
        navigate('/workspace/list');
      }
    }
  }, [navigate, workspaceContext]);

  return <Spinner />;
};
